module.exports = __webpack_public_path__ + "213f20190ed8ff78c56c76ea0fcff44f.pdf";